import { ArticleViewProps } from '@roc-digital/ui-lib';
import { ActionBar } from './ActionBar';
import { MetaBar } from './MetaBar';
import { Card } from './Card';
import { ArticleHeadline } from './ArticleHeadline';
import { ArticleImage } from './ArticleImage';
import './Portrait.scss';

/**
 * Alignment Rules:
 *  - Flex Grow: Should grow equally with other siblings
 *  - Minimum Width: 164px;
 *  - Heights: 284px
 */

export function Portrait(props: ArticleViewProps) {

  const showActions = props.actions !== false;

  const header = <ArticleImage
    className={`bg-gray-200 article-image`}
    src={props.article.image}
    blurhash={props.article?.blurhash}
    style={{ objectFit: 'cover' }}
    onClick={() => props.onAction && props.onAction({action: 'open', articleId: props.article.id})}
    mini={false}
    href={props.article.href}
  />;

  return <Card
    noFrame={props.noFrame}
    className={`portrait-article ${props.className}`}
    orientation={'portrait'}
    header={header}
  >
    {props.hideMeta !== true ? <>
      <MetaBar
        logo={props.article.logo}
        timeLapse={props.article.timeLapse}
        tag={props.hideTag !== true ? props.article.tag : undefined}
      />
    </> : <></>}
    <ArticleHeadline
      size={'sm'}
      headline={props.article.headline}
      blurhash={props.article?.blurhash}
      onClick={() => props.onAction && props.onAction({action: 'open', articleId: props.article.id})}
      children={props.children}
      href={props.article.href}
    />
    {showActions ?
      <ActionBar
        bookmarked={props.article.bookmarked}
        voted={props.article.voted}
        upvotes={props.article.upvotes || 0}
        downvotes={props.article.downvotes || 0}
        articleId={props.article.id || ''}
        comments={props.article.comments}
        onAction={props.onAction || (() => {})}/>
    : null}
  </Card>;
}
